import { render } from "./ModalPausasTrabalho.vue?vue&type=template&id=c09e1368&scoped=true"
import script from "./ModalPausasTrabalho.vue?vue&type=script&lang=js"
export * from "./ModalPausasTrabalho.vue?vue&type=script&lang=js"

import "./ModalPausasTrabalho.vue?vue&type=style&index=0&id=c09e1368&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c09e1368"]])

export default __exports__